import { Checkbox, Form, Input, SubmitButton, SuggestionsInput, useZodForm } from '@/components/Forms'
import styles from './SwitchUserModal.module.scss'
import { switchUserSchema } from './schema'
import { SWITCH_USER_FORM_FIELDS } from '../../config/constants'
import { useSwitchUser } from '../../api/useSwitchUser'
import { useGetEmployees } from '../../api/useGetEmployees'
import { useEffect, useState } from 'react'
import { Employee } from '@/types/user'

export const SwitchUserForm = () => {
    const form = useZodForm({
        schema: switchUserSchema,
        defaultValues: {
            [SWITCH_USER_FORM_FIELDS.author]: '',
            [SWITCH_USER_FORM_FIELDS.badgeNumber]: '',
        },
    })
    const { data: employees } = useGetEmployees(Employee.Controller)
    const { handleSwitchUser, isPending } = useSwitchUser()
    const [selectedEmployeeId, setSelectedEmployeeId] = useState('')

    useEffect(() => {
        // if the employee is selected, set the badge number
        if (selectedEmployeeId) {
            const employee = employees?.find((employee) => employee.badgeNumber === selectedEmployeeId) // TODO: change to id when it will be fixed on the backend
            if (employee) {
                form.setValue(SWITCH_USER_FORM_FIELDS.badgeNumber, employee.badgeNumber, {
                    shouldValidate: true,
                })
            }
        }
    }, [employees, selectedEmployeeId, form])

    useEffect(() => {
        if (form.watch(SWITCH_USER_FORM_FIELDS.noBadge)) {
            form.setValue(SWITCH_USER_FORM_FIELDS.badgeNumber, '', {
                shouldValidate: true,
            })
        }
    }, [form.watch(SWITCH_USER_FORM_FIELDS.noBadge)])

    return (
        <Form form={form} onSubmit={(data) => handleSwitchUser(data)}>
            <div className={styles.formContainer}>
                <h1 className={styles.title}>Switch author</h1>
                <div className={styles.userContainer}>
                    <span className={styles.name}>
                        This will change the author of the Controller Log, but not log you out fully. Use this if you
                        need to record something quickly.
                    </span>
                </div>

                <div className={styles.fieldsContainer}>
                    <SuggestionsInput
                        options={
                            employees
                                ? employees.map((employee) => ({
                                      label: `${employee.firstName} ${employee.lastName}`,
                                      value: `${employee.firstName} ${employee.lastName}`,
                                      id: employee.badgeNumber,
                                  }))
                                : []
                        }
                        placeholder="Name"
                        id="author"
                        maxLength={100}
                        label="Name"
                        setSelectedValue={(value) => setSelectedEmployeeId(value)}
                        {...form.register(SWITCH_USER_FORM_FIELDS.author, {
                            onChange: (e) => {
                                form.setValue(SWITCH_USER_FORM_FIELDS.author, e.target.value, {
                                    shouldValidate: true,
                                })
                            },
                        })}
                    />

                    <div className={styles.fieldWrapper}>
                        <Input
                            disabled={form.watch(SWITCH_USER_FORM_FIELDS.noBadge)}
                            type="text"
                            {...form.register(SWITCH_USER_FORM_FIELDS.badgeNumber, {
                                onChange: (e) => {
                                    // Only allow digits
                                    const value = e.target.value.replace(/[^0-9]/g, '')
                                    e.target.value = value
                                    form.setValue(SWITCH_USER_FORM_FIELDS.badgeNumber, value, {
                                        shouldValidate: true,
                                    })
                                    return value
                                },
                            })}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            label="Badge number"
                            placeholder="Badge number"
                            id="badgeNumber"
                            fullWidth
                            allowClear
                            iconClassName={styles.badgeInput}
                        />
                        <Checkbox name={SWITCH_USER_FORM_FIELDS.noBadge} label="I don’t have a badge number yet" />
                    </div>
                </div>

                <div className={styles.submitButtonContainer}>
                    <SubmitButton
                        className={styles.submitButton}
                        disabled={!form.formState.isValid || isPending}
                        rounded
                    >
                        Switch user
                    </SubmitButton>
                </div>
            </div>
        </Form>
    )
}
